import React, { useEffect, useState } from "react";
import Pagination from "../../Components/Pagination/Pagination";
import ServiceSkeleton from "../../Components/Loader/Skeleton/ServiceSkeleton";
import { getPayloadHash } from "../../services/helper";
import { postFormDataCall } from "../../services/apiCall";

const Service = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = 10;

  const [isLoading, setIsLoading] = useState(true);
  const [serviceOption, setServiceOption] = useState([]);

  const [categoryOption, setCategoryOption] = useState([]);
  const [category, setCategory] = useState(null);

  const getServices = async () => {
    setIsLoading(true);
    const payload = {};
    let dataToSend = { data: getPayloadHash({ data: payload }) };

    let response = await postFormDataCall("/service-for-user", {}, dataToSend);
    if (response?.success && response?.data) {
      setServiceOption(response?.data);
    }
    setIsLoading(false);

    let responseForServiceType = await postFormDataCall(
      "/get-service-types",
      {},
      dataToSend
    );
    if (responseForServiceType?.success && responseForServiceType?.data) {
      setCategoryOption(responseForServiceType?.data);
    }
  };

  useEffect(() => {
    getServices();
  }, []);

  // Filter services based on selected category
  const filteredServices = category
    ? serviceOption.filter((service) => service?.category_id === category)
    : serviceOption;

  const works = [
    {
      icon: "https://demo.websolutionus.com/aabcserv/uploads/custom-images/how-it-work-2022-09-29-12-20-12-1071.png",
      title: "Sign Up",
      description: "Create your profile in minutes",
    },
    {
      icon: "https://demo.websolutionus.com/aabcserv/uploads/custom-images/how-it-work-2022-09-29-12-20-54-8399.png",
      title: "Login",
      description:
        "Worker can Login and go live to get Part Time work Bookings / Employer can login and Post the Jobs or list openings effortlessly",
    },
    {
      icon: "https://demo.websolutionus.com/aabcserv/uploads/custom-images/how-it-work-2022-09-29-12-21-46-2428.png",
      title: "Enjoy Services",
      description:
        "If you are going to use a passage of you need to be sure there isn't anything embarrassing hidden in the middle.",
    },
  ];

  return (
    <div className="w-full ">
      <section className="py-16 px-4 sm:px-6 max-w-7xl mx-auto">
        {/* Header Section */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Our Services
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Discover our comprehensive range of professional services tailored
            to meet your needs
          </p>
        </div>

        {/* Filter Section */}
        <div className="flex flex-col md:flex-row justify-center items-center gap-6 py-6 mb-8">
          <div className="w-full md:w-1/3 lg:w-1/4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Filter by Category
            </label>
            <div className="relative">
              <select
                className="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 cursor-pointer appearance-none bg-white"
                onChange={(e) =>
                  setCategory(e.target.value ? parseInt(e.target.value) : null)
                }
                value={category || ""}
              >
                <option value="">All Categories</option>
                {categoryOption.map((option, i) => (
                  <option key={i} value={option.service_type_id}>
                    {option.service_type}
                  </option>
                ))}
              </select>
              <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                <svg
                  className="h-5 w-5 text-gray-400"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>

        {/* Services Grid */}
        {isLoading ? (
          <ServiceSkeleton />
        ) : (
          <>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredServices.map((service, idx) => (
                <div
                  key={`${service.id}-${idx}`}
                  className="bg-white rounded-xl shadow-lg overflow-hidden transition-all duration-300 hover:shadow-xl hover:-translate-y-1"
                >
                  <div className="relative h-60 overflow-hidden">
                    <img
                      src={
                        service.subcategory_image || "https://placehold.co/400"
                      }
                      alt={service.subcategory_name}
                      className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                    />
                    <span className="absolute top-4 left-4 bg-blue-600 text-white px-3 py-1 text-xs font-semibold rounded-full">
                      {service.service_type}
                    </span>
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-gray-800 mb-2 line-clamp-2">
                      {service.subcategory_name}
                    </h3>
                    <p className="text-gray-600 text-sm mb-4 line-clamp-3">
                      {service.description}
                    </p>
                    <button className="w-full bg-gradient-to-r from-blue-600 to-blue-500 text-white py-3 rounded-lg font-medium hover:from-blue-700 hover:to-blue-600 transition-all duration-300 shadow-md hover:shadow-lg">
                      Book Now
                    </button>
                  </div>
                </div>
              ))}
            </div>

            {/* Pagination */}
            {/* {filteredServices.length > 0 && (
              <div className="mt-12 flex justify-center">
                <nav className="flex items-center gap-1">
                  <button
                    onClick={() =>
                      setCurrentPage((prev) => Math.max(prev - 1, 1))
                    }
                    disabled={currentPage === 1}
                    className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Previous
                  </button>

                  {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                    let pageNum;
                    if (totalPages <= 5) {
                      pageNum = i + 1;
                    } else if (currentPage <= 3) {
                      pageNum = i + 1;
                    } else if (currentPage >= totalPages - 2) {
                      pageNum = totalPages - 4 + i;
                    } else {
                      pageNum = currentPage - 2 + i;
                    }

                    return (
                      <button
                        key={pageNum}
                        onClick={() => setCurrentPage(pageNum)}
                        className={`px-4 py-2 border rounded-md ${
                          currentPage === pageNum
                            ? "bg-blue-600 text-white border-blue-600"
                            : "border-gray-300 text-gray-700 hover:bg-gray-50"
                        }`}
                      >
                        {pageNum}
                      </button>
                    );
                  })}

                  {totalPages > 5 && currentPage < totalPages - 2 && (
                    <span className="px-2 py-2">...</span>
                  )}

                  {totalPages > 5 && currentPage < totalPages - 2 && (
                    <button
                      onClick={() => setCurrentPage(totalPages)}
                      className={`px-4 py-2 border rounded-md ${
                        currentPage === totalPages
                          ? "bg-blue-600 text-white border-blue-600"
                          : "border-gray-300 text-gray-700 hover:bg-gray-50"
                      }`}
                    >
                      {totalPages}
                    </button>
                  )}

                  <button
                    onClick={() =>
                      setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                    }
                    disabled={currentPage === totalPages}
                    className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Next
                  </button>
                </nav>
              </div>
            )} */}
          </>
        )}
      </section>

      <section className="py-16 px-6 bg-gradient-to-br from-indigo-50 to-purple-50">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-bold text-center text-gray-900 mb-4">
            Gigz App - Part-Time Employment Solutions
          </h2>
          <p className="text-lg text-center text-gray-600 mb-12 max-w-3xl mx-auto">
            Connecting part-time job seekers with employers instantly through
            our AI-powered platform
          </p>
          {/* Available Roles Section - Moved Below */}
          <div className="my-16 bg-white rounded-xl shadow-lg overflow-hidden">
            <div className="bg-gradient-to-r from-indigo-600 to-blue-600 p-8">
              <h3 className="text-2xl font-bold text-white text-center">
                Available Part-Time Roles
              </h3>
              <p className="text-indigo-100 text-center mt-2">
                Find your perfect match from these popular categories
              </p>
            </div>
            <div className="p-8">
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                {[
                  { name: "Housekeeping", icon: "🧹" },
                  { name: "Dishwashers", icon: "🍽️" },
                  { name: "Waiters", icon: "👔" },
                  { name: "Kitchen Helpers", icon: "👨‍🍳" },
                  { name: "Driver/Valet", icon: "🚗" },
                  { name: "Security", icon: "🛡️" },
                  { name: "Labours", icon: "👷" },
                  { name: "Cook", icon: "👩‍🍳" },
                  { name: "Cleaner", icon: "🧽" },
                  { name: "Car Washer", icon: "🚿" },
                  { name: "HV Operators", icon: "🏗️" },
                  { name: "Many More", icon: "➕" },
                ].map((role, index) => (
                  <div
                    key={index}
                    className="flex flex-col items-center p-4 bg-gray-50 rounded-lg hover:bg-indigo-50 transition-colors"
                  >
                    <span className="text-2xl mb-2">{role.icon}</span>
                    <span className="text-gray-800 font-medium text-center">
                      {role.name}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="flex  gap-8 items-stretch">
            {/* Vertical Divider - Visible only on large screens */}
            <div className="hidden lg:block w-px bg-gradient-to-b from-transparent via-gray-300 to-transparent"></div>
          </div>

          <section className="py-16 bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              {/* Section Header */}
              <div className="text-center mb-16">
                <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
                  Our Platform Benefits
                </h2>
                <p className="mt-4 max-w-2xl text-xl text-gray-600 mx-auto">
                  Designed for both job seekers and employers to create perfect
                  matches
                </p>
              </div>

              {/* Cards Container */}
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid gap-16">
                  {/* Job Seekers Card - Enhanced */}
                  <div className="bg-white rounded-2xl shadow-lg overflow-hidden transition-all duration-300 hover:shadow-xl">
                    <div className="flex flex-col lg:flex-row">
                      {/* Image Section */}
                      <div className="relative lg:w-5/12">
                        <img
                          src="https://demo.websolutionus.com/aabcserv/uploads/website-images/about-us-bg-2022-08-28-01-05-24-2606.jpg"
                          alt="Job seeker finding opportunities"
                          className="w-full h-64 lg:h-full object-cover"
                        />
                        <img
                          src="https://demo.websolutionus.com/aabcserv/uploads/website-images/about-us-foreground-2022-08-28-01-05-24-9243.jpg"
                          alt="Happy professional"
                          className="absolute -bottom-6 -right-6 rounded-lg shadow-xl w-28 h-28 md:w-36 md:h-36 object-cover border-4 border-white"
                        />
                      </div>

                      {/* Content Section */}
                      <div className="lg:w-7/12">
                        <div className="bg-gradient-to-r from-purple-600 to-indigo-700 p-6">
                          <div className="flex items-center">
                            <div className="bg-white/20 p-2 rounded-lg mr-4">
                              <svg
                                className="h-8 w-8 text-white"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                                />
                              </svg>
                            </div>
                            <div>
                              <h3 className="text-2xl font-bold text-white">
                                For Workers
                              </h3>
                              <p className="text-purple-100 mt-1">
                                Find flexible work that fits your life
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="p-8">
                          <ul className="space-y-5 mb-8">
                            <li className="flex">
                              <div className="bg-purple-100 p-1.5 rounded-full mr-4 flex-shrink-0">
                                <svg
                                  className="h-5 w-5 text-purple-600"
                                  fill="currentColor"
                                  viewBox="0 0 20 20"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                              </div>
                              <div>
                                <h4 className="text-lg font-semibold text-gray-800">
                                  Instant Job Matching
                                </h4>
                                <p className="text-gray-500">
                                  Get matched with jobs in minutes
                                </p>
                              </div>
                            </li>
                            <li className="flex">
                              <div className="bg-purple-100 p-1.5 rounded-full mr-4 flex-shrink-0">
                                <svg
                                  className="h-5 w-5 text-purple-600"
                                  fill="currentColor"
                                  viewBox="0 0 20 20"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                              </div>
                              <div>
                                <h4 className="text-lg font-semibold text-gray-800">
                                  Flexible Hours
                                </h4>
                                <p className="text-gray-500">
                                  Work when you want
                                </p>
                              </div>
                            </li>
                            <li className="flex">
                              <div className="bg-purple-100 p-1.5 rounded-full mr-4 flex-shrink-0">
                                <svg
                                  className="h-5 w-5 text-purple-600"
                                  fill="currentColor"
                                  viewBox="0 0 20 20"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                              </div>
                              <div>
                                <h4 className="text-lg font-semibold text-gray-800">
                                  Quick Payments
                                </h4>
                                <p className="text-gray-500">
                                  Get paid immediately after work
                                </p>
                              </div>
                            </li>
                          </ul>
                          <button className="w-full bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 text-white font-semibold py-3 px-6 rounded-lg transition duration-300 flex items-center justify-center shadow-md hover:shadow-lg">
                            Apply Now
                            <svg
                              className="w-5 h-5 ml-2"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M14 5l7 7m0 0l-7 7m7-7H3"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Employers Card - Enhanced */}
                  <div className="bg-white rounded-2xl shadow-lg overflow-hidden transition-all duration-300 hover:shadow-xl">
                    <div className="flex flex-col lg:flex-row-reverse">
                      {/* Image Section */}
                      <div className="relative lg:w-5/12">
                        <img
                          src="https://demo.websolutionus.com/aabcserv/uploads/website-images/about-us-bg-2022-08-28-01-40-24-9733.jpg"
                          alt="Employer managing team"
                          className="w-full h-64 lg:h-full object-cover"
                        />
                        <img
                          src="https://demo.websolutionus.com/aabcserv/uploads/website-images/about-us-foreground-2022-08-28-01-40-33-7719.jpg"
                          alt="Professional technician"
                          className="absolute -bottom-6 -left-6 rounded-lg shadow-xl w-28 h-28 md:w-36 md:h-36 object-cover border-4 border-white"
                        />
                      </div>

                      {/* Content Section */}
                      <div className="lg:w-7/12">
                        <div className="bg-gradient-to-r from-blue-600 to-cyan-600 p-6">
                          <div className="flex items-center">
                            <div className="bg-white/20 p-2 rounded-lg mr-4">
                              <svg
                                className="h-8 w-8 text-white"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                                />
                              </svg>
                            </div>
                            <div>
                              <h3 className="text-2xl font-bold text-white">
                                For Employers
                              </h3>
                              <p className="text-blue-100 mt-1">
                                Find reliable staff quickly
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="p-8">
                          <ul className="space-y-5 mb-8">
                            <li className="flex">
                              <div className="bg-blue-100 p-1.5 rounded-full mr-4 flex-shrink-0">
                                <svg
                                  className="h-5 w-5 text-blue-600"
                                  fill="currentColor"
                                  viewBox="0 0 20 20"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                              </div>
                              <div>
                                <h4 className="text-lg font-semibold text-gray-800">
                                  On-Demand Hiring
                                </h4>
                                <p className="text-gray-500">
                                  Fill shifts in minutes, not days
                                </p>
                              </div>
                            </li>
                            <li className="flex">
                              <div className="bg-blue-100 p-1.5 rounded-full mr-4 flex-shrink-0">
                                <svg
                                  className="h-5 w-5 text-blue-600"
                                  fill="currentColor"
                                  viewBox="0 0 20 20"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                              </div>
                              <div>
                                <h4 className="text-lg font-semibold text-gray-800">
                                  AI Screening
                                </h4>
                                <p className="text-gray-500">
                                  Get quality candidates fast
                                </p>
                              </div>
                            </li>
                            <li className="flex">
                              <div className="bg-blue-100 p-1.5 rounded-full mr-4 flex-shrink-0">
                                <svg
                                  className="h-5 w-5 text-blue-600"
                                  fill="currentColor"
                                  viewBox="0 0 20 20"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                              </div>
                              <div>
                                <h4 className="text-lg font-semibold text-gray-800">
                                  Reliable Workforce
                                </h4>
                                <p className="text-gray-500">
                                  Verified, trained professionals
                                </p>
                              </div>
                            </li>
                          </ul>
                          <button className="w-full bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-700 hover:to-cyan-700 text-white font-semibold py-3 px-6 rounded-lg transition duration-300 flex items-center justify-center shadow-md hover:shadow-lg">
                            Apply Now
                            <svg
                              className="w-5 h-5 ml-2"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M14 5l7 7m0 0l-7 7m7-7H3"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* App Download CTA - Enhanced */}
          <div className="mt-16 bg-gradient-to-br from-purple-600 to-indigo-700 rounded-2xl p-10 text-center text-white overflow-hidden relative">
            <div className="absolute -right-10 -top-10 w-32 h-32 bg-white/10 rounded-full"></div>
            <div className="absolute -left-10 -bottom-10 w-40 h-40 bg-white/5 rounded-full"></div>
            <div className="relative z-10">
              <h3 className="text-3xl font-bold mb-4">
                Get Started in Minutes
              </h3>
              <p className="text-purple-100 mb-8 max-w-2xl mx-auto text-lg">
                Download the Gigz app today and transform your part-time
                employment experience
              </p>
              <div className="flex flex-col sm:flex-row justify-center gap-4">
                <button className="bg-black hover:bg-gray-900 text-white px-8 py-4 rounded-lg flex items-center justify-center transition duration-300 shadow-lg hover:shadow-xl">
                  <div className="mr-3">
                    <svg
                      className="w-6 h-6"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.8 1.01.03 2.06.33 2.77 1.02-2.44 1.27-1.81 4.45.31 5.58-.71 1.03-1.65 2.04-2.95 1.99-.5-.02-1.04-.17-1.55-.27-.39 1.21-.74 2.39-1.96 3.05zm-3.03-13.4c.55-1.38 1.51-2.53 2.42-3.28-.36 1.21-.97 2.3-1.82 3.2 1.19.03 1.94-.16 2.72-.92-.46.56-1.03 1.06-1.67 1.5-.59-.8-1.22-1.74-1.65-2.5z" />
                    </svg>
                  </div>
                  <div className="text-left">
                    {/* <div className="text-xs">Download on the</div> */}
                    <div className="text-xl font-semibold -mt-1">App Store</div>
                  </div>
                </button>
                <button className="bg-black hover:bg-gray-900 text-white px-8 py-4 rounded-lg flex items-center justify-center transition duration-300 shadow-lg hover:shadow-xl">
                  <div className="mr-3">
                    <svg
                      className="w-6 h-6"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M3 20.5v-17c0-.59.34-1.11.84-1.35L13.69 12l-9.85 9.85c-.5-.25-.84-.76-.84-1.35m13.81-5.38L6.05 21.34l8.49-8.49 2.27 2.27m3.35-4.31c.34.27.59.69.59 1.19s-.22.9-.57 1.18l-2.29 1.32-2.5-2.5 2.5-2.5 2.27 1.31M6.05 2.66l10.76 6.22-2.27 2.27-8.49-8.49z" />
                    </svg>
                  </div>
                  <div className="text-left">
                    {/* <div className="text-xs">Get it on</div> */}
                    <div className="text-xl font-semibold -mt-1">
                      Google Play
                    </div>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Existing Sections */}
      <section className="py-12 px-6 text-center max-w-7xl mx-auto">
        <h2 className="text-3xl font-bold">How It Works</h2>
        <p className="text-gray-800 mt-2">
          Download the <span className="text-blue-500"> GigzApp </span>
          from playstore or AppStore
        </p>

        <div className="container mx-auto mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
          {works.map((works, index) => (
            <div
              key={`${works.title}-${index}`}
              className="flex flex-col items-center"
            >
              <div className="bg-blue-500 p-4 rounded-full">
                <img src={works.icon} alt={works.title} className="w-16 h-16" />
              </div>
              <h3 className="text-lg font-semibold mt-4">{works.title}</h3>
              <p className="text-gray-800 mt-2 px-4">{works.description}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Service;
